(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], function(){ return factory(root); });
  } else if (typeof module === 'object' && module.exports) {
    module.exports = factory(globalThis || (typeof self !== 'undefined' ? self : this));
  } else {
    root.SwishShuffleboardLines = factory(root);
  }
}(typeof self !== 'undefined' ? self : this, function (GLOBAL) {
  'use strict';

  function normHex(x){ if(!x) return '#FFFFFF'; x=String(x).trim(); if(x[0] !== '#') x='#'+x; return x.toUpperCase(); }
  function hasKeys(obj) {
    if (!obj) return false;
    for (const _ in obj) return true;
    return false;
  }
  function resolveOfficial(rulesetId) {
    const cfg = GLOBAL && GLOBAL.SwishCBConfig;
    if (cfg && typeof cfg.resolveOfficialCourtGeometry === 'function') {
      try { return cfg.resolveOfficialCourtGeometry(rulesetId, { noSeries: true }); } catch (_) {}
    }
    return null;
  }

  const FT = 0.3048;
  const IN = 0.0254;
  const OFFICIAL = resolveOfficial('SHUFFLEBOARD');
  const OFFICIAL_FEATURE = OFFICIAL && OFFICIAL.features && OFFICIAL.features.shuffleboard;
  const COURT = {
    LENGTH: Number(OFFICIAL && OFFICIAL.officialLengthM) || (52 * FT),
    WIDTH: Number(OFFICIAL && OFFICIAL.officialWidthM) || (6 * FT),
    BASE_LINE: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.baseLineFromEndM) || (6.5 * FT),
    TEN_OFF_DEPTH: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.tenOffDepthM) || (1.5 * FT),
    BAND: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.scoringBandM) || (3 * FT),
    TRIANGLE: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.triangleDepthM) || (9 * FT),
    DEAD_GAP: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.deadLineGapM) || (3 * FT),
    TEN_OFF_SIDE_INSET: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.tenOffSideInsetM) || (0.5 * FT),
    TEN_OFF_SEPARATOR_HALF_BASE: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.tenOffSeparatorHalfBaseM) || (1.5 * IN),
    LINE: Number(OFFICIAL && OFFICIAL.lineWidthM) || IN
  };
  const CENTER_Y = COURT.WIDTH / 2;
  const SKIP_COLOR = '__SKIP__';
  const LABEL_SIZE = 0.5 * FT;

  function makePart(id, order, role, fallback, side, draw) {
    return { id, order, role, fallback, side, draw };
  }

  function computeDims(cw, ch) {
    const scaleX = cw / COURT.LENGTH;
    const scaleY = ch / COURT.WIDTH;
    return {
      scaleX,
      scaleY,
      scaleAvg: (scaleX + scaleY) * 0.5,
      cw,
      ch
    };
  }

  function px(dims, x, y) {
    return { x: x * dims.scaleX, y: y * dims.scaleY };
  }

  function lineWidthPx(dims) {
    return Math.max(1, COURT.LINE * dims.scaleAvg);
  }

  function fillLineH(ctx, dims, color, x1, x2, yM, widthM, align) {
    const wPx = Math.max(1, widthM * dims.scaleAvg);
    const xPx1 = x1 * dims.scaleX;
    const xPx2 = x2 * dims.scaleX;
    const left = Math.min(xPx1, xPx2);
    const width = Math.abs(xPx2 - xPx1);
    const yPx = yM * dims.scaleY;
    const top =
      align === 'inside-top' ? yPx :
      align === 'inside-bottom' ? (yPx - wPx) :
      (yPx - wPx / 2);
    ctx.save();
    ctx.fillStyle = color;
    ctx.fillRect(left, top, width, wPx);
    ctx.restore();
  }

  function fillLineV(ctx, dims, color, xM, y1, y2, widthM, align) {
    const wPx = Math.max(1, widthM * dims.scaleAvg);
    const yPx1 = y1 * dims.scaleY;
    const yPx2 = y2 * dims.scaleY;
    const top = Math.min(yPx1, yPx2);
    const height = Math.abs(yPx2 - yPx1);
    const xPx = xM * dims.scaleX;
    const left =
      align === 'inside-left' ? xPx :
      align === 'inside-right' ? (xPx - wPx) :
      (xPx - wPx / 2);
    ctx.save();
    ctx.fillStyle = color;
    ctx.fillRect(left, top, wPx, height);
    ctx.restore();
  }

  function fillSegment(ctx, dims, a, b) {
    const p0 = px(dims, a[0], a[1]);
    const p1 = px(dims, b[0], b[1]);
    const dx = p1.x - p0.x;
    const dy = p1.y - p0.y;
    const len = Math.sqrt((dx * dx) + (dy * dy));
    if (!(len > 0)) return;
    const half = lineWidthPx(dims) * 0.5;
    const nx = (-dy / len) * half;
    const ny = (dx / len) * half;
    ctx.beginPath();
    ctx.moveTo(p0.x + nx, p0.y + ny);
    ctx.lineTo(p1.x + nx, p1.y + ny);
    ctx.lineTo(p1.x - nx, p1.y - ny);
    ctx.lineTo(p0.x - nx, p0.y - ny);
    ctx.closePath();
    ctx.fill();
  }

  function drawPath(ctx, dims, color, points, close) {
    if (!points || points.length < 2) return;
    ctx.save();
    ctx.fillStyle = color;
    for (let i = 1; i < points.length; i += 1) {
      fillSegment(ctx, dims, points[i - 1], points[i]);
    }
    if (close) fillSegment(ctx, dims, points[points.length - 1], points[0]);
    ctx.restore();
  }

  function fillRect(ctx, dims, color, x, y, w, h) {
    ctx.save();
    ctx.fillStyle = (GLOBAL.SwishCBHardwood && typeof GLOBAL.SwishCBHardwood.getFillStyle === 'function')
      ? GLOBAL.SwishCBHardwood.getFillStyle(ctx, color, { hardwood: dims.hardwood, pixelsPerMeter: dims.scaleAvg })
      : color;
    ctx.fillRect(x * dims.scaleX, y * dims.scaleY, w * dims.scaleX, h * dims.scaleY);
    ctx.restore();
  }

  function fillPolygon(ctx, dims, color, points) {
    if (!points || points.length < 3) return;
    ctx.save();
    ctx.fillStyle = (GLOBAL.SwishCBHardwood && typeof GLOBAL.SwishCBHardwood.getFillStyle === 'function')
      ? GLOBAL.SwishCBHardwood.getFillStyle(ctx, color, { hardwood: dims.hardwood, pixelsPerMeter: dims.scaleAvg })
      : color;
    ctx.beginPath();
    const first = px(dims, points[0][0], points[0][1]);
    ctx.moveTo(first.x, first.y);
    for (let i = 1; i < points.length; i += 1) {
      const next = px(dims, points[i][0], points[i][1]);
      ctx.lineTo(next.x, next.y);
    }
    ctx.closePath();
    ctx.fill();
    ctx.restore();
  }

  function xFromEnd(side, distanceM) {
    return side === 'right' ? COURT.LENGTH - distanceM : distanceM;
  }

  function triangleBoundsAtDistance(distanceM) {
    const baseDistance = COURT.BASE_LINE + COURT.TEN_OFF_DEPTH;
    const tipDistance = baseDistance + COURT.TRIANGLE;
    const ratio = Math.max(0, Math.min(1, (tipDistance - distanceM) / COURT.TRIANGLE));
    const half = (COURT.WIDTH / 2) * ratio;
    return {
      top: CENTER_Y - half,
      bottom: CENTER_Y + half
    };
  }

  function endPoint(side, distanceM, yM) {
    return [xFromEnd(side, distanceM), yM];
  }

  function lineAcross(side, distanceM) {
    return [endPoint(side, distanceM, 0), endPoint(side, distanceM, COURT.WIDTH)];
  }

  function lineInTriangle(side, distanceM) {
    const bounds = triangleBoundsAtDistance(distanceM);
    return [endPoint(side, distanceM, bounds.top), endPoint(side, distanceM, bounds.bottom)];
  }

  function triangleSide(side, top) {
    const baseDistance = COURT.BASE_LINE + COURT.TEN_OFF_DEPTH;
    const tipDistance = baseDistance + COURT.TRIANGLE;
    const baseY = top ? 0 : COURT.WIDTH;
    return [endPoint(side, baseDistance, baseY), endPoint(side, tipDistance, CENTER_Y)];
  }

  function tenOffSide(side, top) {
    const baseDistance = COURT.BASE_LINE + COURT.TEN_OFF_DEPTH;
    const baselineInset = COURT.TEN_OFF_SIDE_INSET;
    const startY = top ? baselineInset : COURT.WIDTH - baselineInset;
    const endY = top ? 0 : COURT.WIDTH;
    return [endPoint(side, COURT.BASE_LINE, startY), endPoint(side, baseDistance, endY)];
  }

  function tenOffSeparatorTriangle(side) {
    const baseDistance = COURT.BASE_LINE + COURT.TEN_OFF_DEPTH;
    const halfBase = COURT.TEN_OFF_SEPARATOR_HALF_BASE;
    return [
      [endPoint(side, COURT.BASE_LINE, CENTER_Y - halfBase), endPoint(side, baseDistance, CENTER_Y)],
      [endPoint(side, COURT.BASE_LINE, CENTER_Y + halfBase), endPoint(side, baseDistance, CENTER_Y)]
    ];
  }

  function polygonCentroid(points) {
    if (!points || !points.length) return { x: 0, y: 0 };
    let twiceArea = 0;
    let cx = 0;
    let cy = 0;
    for (let i = 0; i < points.length; i += 1) {
      const p0 = points[i];
      const p1 = points[(i + 1) % points.length];
      const cross = (p0[0] * p1[1]) - (p1[0] * p0[1]);
      twiceArea += cross;
      cx += (p0[0] + p1[0]) * cross;
      cy += (p0[1] + p1[1]) * cross;
    }
    if (Math.abs(twiceArea) < 1e-9) {
      const sum = points.reduce((acc, point) => {
        acc.x += point[0];
        acc.y += point[1];
        return acc;
      }, { x: 0, y: 0 });
      return { x: sum.x / points.length, y: sum.y / points.length };
    }
    return {
      x: cx / (3 * twiceArea),
      y: cy / (3 * twiceArea)
    };
  }

  function triangleZonePolygon(startDistance, endDistance, half) {
    const start = triangleBoundsAtDistance(startDistance);
    const end = triangleBoundsAtDistance(endDistance);
    if (half === 'tip') {
      return [
        [startDistance, start.top],
        [endDistance, CENTER_Y],
        [startDistance, start.bottom]
      ];
    }
    if (half === 'top') {
      return [
        [startDistance, start.top],
        [endDistance, end.top],
        [endDistance, CENTER_Y],
        [startDistance, CENTER_Y]
      ];
    }
    return [
      [startDistance, CENTER_Y],
      [endDistance, CENTER_Y],
      [endDistance, end.bottom],
      [startDistance, start.bottom]
    ];
  }

  function tenOffZonePolygon(half) {
    const baseDistance = COURT.BASE_LINE + COURT.TEN_OFF_DEPTH;
    const baselineInset = COURT.TEN_OFF_SIDE_INSET;
    const separatorHalfBase = COURT.TEN_OFF_SEPARATOR_HALF_BASE;
    if (half === 'top') {
      return [
        [COURT.BASE_LINE, baselineInset],
        [baseDistance, 0],
        [baseDistance, CENTER_Y],
        [COURT.BASE_LINE, CENTER_Y - separatorHalfBase]
      ];
    }
    return [
      [COURT.BASE_LINE, CENTER_Y + separatorHalfBase],
      [baseDistance, CENTER_Y],
      [baseDistance, COURT.WIDTH],
      [COURT.BASE_LINE, COURT.WIDTH - baselineInset]
    ];
  }

  function sideDistancePolygon(side, points) {
    return (points || []).map(point => [xFromEnd(side, point[0]), point[1]]);
  }

  function drawLabel(ctx, dims, color, text, side, distanceM, yM, sizeM) {
    const p = px(dims, xFromEnd(side, distanceM), yM);
    const fontPx = Math.max(6, sizeM * dims.scaleAvg);
    ctx.save();
    ctx.translate(p.x, p.y);
    ctx.rotate(side === 'right' ? -Math.PI / 2 : Math.PI / 2);
    ctx.fillStyle = color;
    ctx.font = `700 ${fontPx}px Arial, sans-serif`;
    ctx.textAlign = 'center';
    if (typeof ctx.measureText === 'function') {
      const metrics = ctx.measureText(text);
      const left = Number(metrics.actualBoundingBoxLeft);
      const right = Number(metrics.actualBoundingBoxRight);
      const ascent = Number(metrics.actualBoundingBoxAscent);
      const descent = Number(metrics.actualBoundingBoxDescent);
      if (Number.isFinite(left) && Number.isFinite(right) && Number.isFinite(ascent) && Number.isFinite(descent)) {
        ctx.textBaseline = 'alphabetic';
        ctx.fillText(text, (left - right) * 0.5, (ascent - descent) * 0.5);
        ctx.restore();
        return;
      }
    }
    ctx.textBaseline = 'middle';
    ctx.fillText(text, 0, 0);
    ctx.restore();
  }

  function drawLabelInPolygon(ctx, dims, color, text, side, points, sizeM) {
    const center = polygonCentroid(points);
    drawLabel(ctx, dims, color, text, side, center.x, center.y, sizeM);
  }

  function drawLabelsForEnd(ctx, dims, color, side) {
    drawLabelInPolygon(ctx, dims, color, '10', side, triangleZonePolygon(eightTenDistance, tipDistance, 'tip'), LABEL_SIZE);
    drawLabelInPolygon(ctx, dims, color, '8', side, triangleZonePolygon(sevenEightDistance, eightTenDistance, 'top'), LABEL_SIZE);
    drawLabelInPolygon(ctx, dims, color, '8', side, triangleZonePolygon(sevenEightDistance, eightTenDistance, 'bottom'), LABEL_SIZE);
    drawLabelInPolygon(ctx, dims, color, '7', side, triangleZonePolygon(baseDistance, sevenEightDistance, 'top'), LABEL_SIZE);
    drawLabelInPolygon(ctx, dims, color, '7', side, triangleZonePolygon(baseDistance, sevenEightDistance, 'bottom'), LABEL_SIZE);
    drawLabelInPolygon(ctx, dims, color, 'OFF', side, tenOffZonePolygon('top'), LABEL_SIZE);
    drawLabelInPolygon(ctx, dims, color, '10', side, tenOffZonePolygon('bottom'), LABEL_SIZE);
  }

  const baseDistance = COURT.BASE_LINE + COURT.TEN_OFF_DEPTH;
  const sevenEightDistance = baseDistance + COURT.BAND;
  const eightTenDistance = baseDistance + (COURT.BAND * 2);
  const tipDistance = baseDistance + COURT.TRIANGLE;
  const deadLineDistance = tipDistance + COURT.DEAD_GAP;

  const PARTS = [
    makePart('shuffleLeftCourtArea', 10, 'area', 'main', 'left', (ctx, dims, color) => {
      fillRect(ctx, dims, color, 0, 0, COURT.LENGTH * 0.5, COURT.WIDTH);
    }),
    makePart('shuffleRightCourtArea', 20, 'area', 'main', 'right', (ctx, dims, color) => {
      fillRect(ctx, dims, color, COURT.LENGTH * 0.5, 0, COURT.LENGTH * 0.5, COURT.WIDTH);
    }),

    makePart('shuffleLeftTenOffTopArea', 30, 'area', 'main', 'left', (ctx, dims, color) => {
      fillPolygon(ctx, dims, color, sideDistancePolygon('left', tenOffZonePolygon('top')));
    }),
    makePart('shuffleLeftTenOffBottomArea', 40, 'area', 'main', 'left', (ctx, dims, color) => {
      fillPolygon(ctx, dims, color, sideDistancePolygon('left', tenOffZonePolygon('bottom')));
    }),
    makePart('shuffleLeftSevenTopArea', 50, 'area', 'main', 'left', (ctx, dims, color) => {
      fillPolygon(ctx, dims, color, sideDistancePolygon('left', triangleZonePolygon(baseDistance, sevenEightDistance, 'top')));
    }),
    makePart('shuffleLeftSevenBottomArea', 60, 'area', 'main', 'left', (ctx, dims, color) => {
      fillPolygon(ctx, dims, color, sideDistancePolygon('left', triangleZonePolygon(baseDistance, sevenEightDistance, 'bottom')));
    }),
    makePart('shuffleLeftEightTopArea', 70, 'area', 'main', 'left', (ctx, dims, color) => {
      fillPolygon(ctx, dims, color, sideDistancePolygon('left', triangleZonePolygon(sevenEightDistance, eightTenDistance, 'top')));
    }),
    makePart('shuffleLeftEightBottomArea', 80, 'area', 'main', 'left', (ctx, dims, color) => {
      fillPolygon(ctx, dims, color, sideDistancePolygon('left', triangleZonePolygon(sevenEightDistance, eightTenDistance, 'bottom')));
    }),
    makePart('shuffleLeftTenArea', 90, 'area', 'main', 'left', (ctx, dims, color) => {
      fillPolygon(ctx, dims, color, sideDistancePolygon('left', triangleZonePolygon(eightTenDistance, tipDistance, 'tip')));
    }),

    makePart('shuffleRightTenOffTopArea', 92, 'area', 'main', 'right', (ctx, dims, color) => {
      fillPolygon(ctx, dims, color, sideDistancePolygon('right', tenOffZonePolygon('top')));
    }),
    makePart('shuffleRightTenOffBottomArea', 94, 'area', 'main', 'right', (ctx, dims, color) => {
      fillPolygon(ctx, dims, color, sideDistancePolygon('right', tenOffZonePolygon('bottom')));
    }),
    makePart('shuffleRightSevenTopArea', 96, 'area', 'main', 'right', (ctx, dims, color) => {
      fillPolygon(ctx, dims, color, sideDistancePolygon('right', triangleZonePolygon(baseDistance, sevenEightDistance, 'top')));
    }),
    makePart('shuffleRightSevenBottomArea', 98, 'area', 'main', 'right', (ctx, dims, color) => {
      fillPolygon(ctx, dims, color, sideDistancePolygon('right', triangleZonePolygon(baseDistance, sevenEightDistance, 'bottom')));
    }),
    makePart('shuffleRightEightTopArea', 99.1, 'area', 'main', 'right', (ctx, dims, color) => {
      fillPolygon(ctx, dims, color, sideDistancePolygon('right', triangleZonePolygon(sevenEightDistance, eightTenDistance, 'top')));
    }),
    makePart('shuffleRightEightBottomArea', 99.2, 'area', 'main', 'right', (ctx, dims, color) => {
      fillPolygon(ctx, dims, color, sideDistancePolygon('right', triangleZonePolygon(sevenEightDistance, eightTenDistance, 'bottom')));
    }),
    makePart('shuffleRightTenArea', 99.3, 'area', 'main', 'right', (ctx, dims, color) => {
      fillPolygon(ctx, dims, color, sideDistancePolygon('right', triangleZonePolygon(eightTenDistance, tipDistance, 'tip')));
    }),

    makePart('shuffleSidelineTop', 100, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineH(ctx, dims, color, 0, COURT.LENGTH, 0, COURT.LINE, 'inside-top');
    }),
    makePart('shuffleSidelineBottom', 110, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineH(ctx, dims, color, 0, COURT.LENGTH, COURT.WIDTH, COURT.LINE, 'inside-bottom');
    }),
    makePart('shuffleEndLineLeft', 120, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineV(ctx, dims, color, 0, 0, COURT.WIDTH, COURT.LINE, 'inside-left');
    }),
    makePart('shuffleEndLineRight', 130, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineV(ctx, dims, color, COURT.LENGTH, 0, COURT.WIDTH, COURT.LINE, 'inside-right');
    }),

    makePart('shuffleLeftBaseLine', 200, 'line', 'lines', 'left', (ctx, dims, color) => {
      drawPath(ctx, dims, color, lineAcross('left', COURT.BASE_LINE));
    }),
    makePart('shuffleLeftTenOffLine', 210, 'line', 'lines', 'left', (ctx, dims, color) => {
      drawPath(ctx, dims, color, lineAcross('left', baseDistance));
    }),
    makePart('shuffleLeftTriangleSideTop', 220, 'line', 'lines', 'left', (ctx, dims, color) => {
      drawPath(ctx, dims, color, triangleSide('left', true));
      drawPath(ctx, dims, color, tenOffSide('left', true));
    }),
    makePart('shuffleLeftTriangleSideBottom', 230, 'line', 'lines', 'left', (ctx, dims, color) => {
      drawPath(ctx, dims, color, triangleSide('left', false));
      drawPath(ctx, dims, color, tenOffSide('left', false));
    }),
    makePart('shuffleLeftSevenEightLine', 240, 'line', 'lines', 'left', (ctx, dims, color) => {
      drawPath(ctx, dims, color, lineInTriangle('left', sevenEightDistance));
    }),
    makePart('shuffleLeftEightTenLine', 250, 'line', 'lines', 'left', (ctx, dims, color) => {
      drawPath(ctx, dims, color, lineInTriangle('left', eightTenDistance));
    }),
    makePart('shuffleLeftCenterLine', 260, 'line', 'lines', 'left', (ctx, dims, color) => {
      drawPath(ctx, dims, color, [endPoint('left', baseDistance, CENTER_Y), endPoint('left', eightTenDistance, CENTER_Y)]);
    }),
    makePart('shuffleLeftTenOffTriangle', 270, 'line', 'lines', 'left', (ctx, dims, color) => {
      tenOffSeparatorTriangle('left').forEach(points => drawPath(ctx, dims, color, points));
    }),
    makePart('shuffleLeftDeadLine', 280, 'line', 'lines', 'left', (ctx, dims, color) => {
      drawPath(ctx, dims, color, lineAcross('left', deadLineDistance));
    }),
    makePart('shuffleLeftLabels', 290, 'line', 'lines', 'left', (ctx, dims, color) => {
      drawLabelsForEnd(ctx, dims, color, 'left');
    }),

    makePart('shuffleRightBaseLine', 300, 'line', 'lines', 'right', (ctx, dims, color) => {
      drawPath(ctx, dims, color, lineAcross('right', COURT.BASE_LINE));
    }),
    makePart('shuffleRightTenOffLine', 310, 'line', 'lines', 'right', (ctx, dims, color) => {
      drawPath(ctx, dims, color, lineAcross('right', baseDistance));
    }),
    makePart('shuffleRightTriangleSideTop', 320, 'line', 'lines', 'right', (ctx, dims, color) => {
      drawPath(ctx, dims, color, triangleSide('right', true));
      drawPath(ctx, dims, color, tenOffSide('right', true));
    }),
    makePart('shuffleRightTriangleSideBottom', 330, 'line', 'lines', 'right', (ctx, dims, color) => {
      drawPath(ctx, dims, color, triangleSide('right', false));
      drawPath(ctx, dims, color, tenOffSide('right', false));
    }),
    makePart('shuffleRightSevenEightLine', 340, 'line', 'lines', 'right', (ctx, dims, color) => {
      drawPath(ctx, dims, color, lineInTriangle('right', sevenEightDistance));
    }),
    makePart('shuffleRightEightTenLine', 350, 'line', 'lines', 'right', (ctx, dims, color) => {
      drawPath(ctx, dims, color, lineInTriangle('right', eightTenDistance));
    }),
    makePart('shuffleRightCenterLine', 360, 'line', 'lines', 'right', (ctx, dims, color) => {
      drawPath(ctx, dims, color, [endPoint('right', baseDistance, CENTER_Y), endPoint('right', eightTenDistance, CENTER_Y)]);
    }),
    makePart('shuffleRightTenOffTriangle', 370, 'line', 'lines', 'right', (ctx, dims, color) => {
      tenOffSeparatorTriangle('right').forEach(points => drawPath(ctx, dims, color, points));
    }),
    makePart('shuffleRightDeadLine', 380, 'line', 'lines', 'right', (ctx, dims, color) => {
      drawPath(ctx, dims, color, lineAcross('right', deadLineDistance));
    }),
    makePart('shuffleRightLabels', 390, 'line', 'lines', 'right', (ctx, dims, color) => {
      drawLabelsForEnd(ctx, dims, color, 'right');
    })
  ];

  const PART_LOOKUP = PARTS.reduce((acc, part) => {
    acc[part.id] = part;
    return acc;
  }, Object.create(null));
  const DRAW_ORDER = PARTS.slice().sort((a, b) => a.order - b.order).map(part => part.id);
  const LINE_ONLY_ORDER = DRAW_ORDER.filter(id => PART_LOOKUP[id] && PART_LOOKUP[id].role === 'line');

  function pickDetailColor(detailColors, fallbackColors, id, fallback, baseColor) {
    if (detailColors && detailColors[id]) {
      if (detailColors[id] === SKIP_COLOR) return null;
      return detailColors[id];
    }
    if (fallbackColors && fallbackColors[id]) {
      if (fallbackColors[id] === SKIP_COLOR) return null;
      return fallbackColors[id];
    }
    if (fallback === 'key') return baseColor.key || baseColor.main;
    if (fallback === 'border') return baseColor.border || baseColor.main;
    if (fallback === 'lines') return baseColor.lines;
    return baseColor.main;
  }

  const DEFAULT_PALETTE = {
    main: '#16533A',
    key: '#16533A',
    border: '#0F2F24',
    lines: '#FFFFFF'
  };

  function draw(ctx, x0, y0, cw, ch, color, opts) {
    if (!ctx || !cw || !ch) return;
    const detailColors = (opts && opts.detailColors) || null;
    const fallbackColors = (opts && opts.fallbackColors) || null;
    const only = (opts && (opts.only === 'left' || opts.only === 'right')) ? opts.only : null;
    const useDetailedParts = !!(opts && opts.useDetailedParts);
    const hasCustom = hasKeys(detailColors) || hasKeys(fallbackColors);
    const drawDetailed = useDetailedParts || hasCustom;
    const order = drawDetailed ? DRAW_ORDER : LINE_ONLY_ORDER;

    ctx.save();
    ctx.translate(x0, y0);
    const dims = computeDims(cw, ch);
    dims.hardwood = opts && opts.hardwood;
    const palette = {
      main: DEFAULT_PALETTE.main,
      key: DEFAULT_PALETTE.key,
      border: DEFAULT_PALETTE.border,
      lines: normHex(color || DEFAULT_PALETTE.lines)
    };

    for (const id of order) {
      const part = PART_LOOKUP[id];
      if (!part) continue;
      if (only && part.side && part.side !== only && part.side !== 'center') continue;
      const fill = pickDetailColor(detailColors, fallbackColors, id, part.fallback, palette);
      if (!fill) continue;
      try {
        part.draw(ctx, dims, normHex(fill));
      } catch (err) {
        console.warn('[SwishShuffleboardLines] draw error for part', id, err);
      }
    }

    ctx.restore();
  }

  const api = {
    design: { W: COURT.WIDTH * 1000, L: COURT.LENGTH * 1000 },
    draw,
    ready: Promise.resolve()
  };

  return api;
}));
